<script setup>
import { computed } from 'vue'

const props = defineProps({
  currentPage: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  totalItems: { type: Number, default: 0 },
  pageSize: { type: Number, default: 100 }
})

const emit = defineEmits(['page-change'])

const startItem = computed(() => (props.currentPage - 1) * props.pageSize + 1)
const endItem = computed(() => Math.min(props.currentPage * props.pageSize, props.totalItems))

const changePage = (page) => {
  if (page >= 1 && page <= props.totalPages && page !== props.currentPage) {
    emit('page-change', page)
  }
}
</script>

<template>
  <div v-if="totalPages > 1" class="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2 mt-3 pt-3 border-top">
    <div class="text-muted small">
      Mostrando {{ startItem }} - {{ endItem }} de {{ totalItems }} resultados
    </div>

    <nav aria-label="Navegación de páginas">
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Anterior</button>
        </li>

        <li v-if="currentPage > 2" class="page-item">
          <button class="page-link" @click="changePage(1)">1</button>
        </li>
        <li v-if="currentPage > 3" class="page-item disabled"><span class="page-link">...</span></li>

        <li v-if="currentPage > 1" class="page-item">
          <button class="page-link" @click="changePage(currentPage - 1)">{{ currentPage - 1 }}</button>
        </li>

        <li class="page-item active">
          <span class="page-link">{{ currentPage }}</span>
        </li>

        <li v-if="currentPage < totalPages" class="page-item">
          <button class="page-link" @click="changePage(currentPage + 1)">{{ currentPage + 1 }}</button>
        </li>

        <li v-if="currentPage < totalPages - 2" class="page-item disabled"><span class="page-link">...</span></li>
        <li v-if="currentPage < totalPages - 1" class="page-item">
          <button class="page-link" @click="changePage(totalPages)">{{ totalPages }}</button>
        </li>

        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">Siguiente</button>
        </li>
      </ul>
    </nav>
  </div>
</template>